/**
 * Data layer for `igaming-tiered-commission-by-ngr-ftd-wager-thresholds`. Thin typed fetch wrappers over /api/v1/igaming-tiered-commission-by-ngr-ftd-wager-thresholds.
 * Raw `fetch()` is confined to this file per the dash contract.
 */

export interface IgamingTieredCommissionByNgrFtdWagerThresholdsRow {
	id: string;
	tenant_id: string;
	created_at: number;
	updated_at: number;
	[key: string]: unknown;
}

export interface ListIgamingTieredCommissionByNgrFtdWagerThresholdsResponse {
	count: number;
	items: IgamingTieredCommissionByNgrFtdWagerThresholdsRow[];
}

export interface CreateIgamingTieredCommissionByNgrFtdWagerThresholdsBody {
	[key: string]: unknown;
}

const BASE = "/api/v1/igaming-tiered-commission-by-ngr-ftd-wager-thresholds";

async function parseOrThrow<T>(res: Response): Promise<T> {
	const text = await res.text();
	let data: unknown = null;
	if (text) {
		try {
			data = JSON.parse(text);
		} catch {
			data = text;
		}
	}
	if (!res.ok) {
		const msg =
			data &&
			typeof data === "object" &&
			data !== null &&
			"error" in data &&
			typeof (data as { error: unknown }).error === "string"
				? (data as { error: string }).error
				: `HTTP ${res.status}`;
		throw new Error(msg);
	}
	return data as T;
}

export async function list(): Promise<ListIgamingTieredCommissionByNgrFtdWagerThresholdsResponse> {
	const res = await fetch(BASE, {
		method: "GET",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<ListIgamingTieredCommissionByNgrFtdWagerThresholdsResponse>(res);
}

export async function create(body: CreateIgamingTieredCommissionByNgrFtdWagerThresholdsBody): Promise<IgamingTieredCommissionByNgrFtdWagerThresholdsRow> {
	const res = await fetch(BASE, {
		method: "POST",
		credentials: "include",
		headers: {
			accept: "application/json",
			"content-type": "application/json",
		},
		body: JSON.stringify(body ?? {}),
	});
	return parseOrThrow<IgamingTieredCommissionByNgrFtdWagerThresholdsRow>(res);
}

export async function remove(id: string): Promise<{ removed: boolean }> {
	const res = await fetch(`${BASE}/${encodeURIComponent(id)}`, {
		method: "DELETE",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<{ removed: boolean }>(res);
}

export const igamingTieredCommissionByNgrFtdWagerThresholdsQueryKeys = {
	all: ["igaming-tiered-commission-by-ngr-ftd-wager-thresholds"] as const,
	list: () => [...igamingTieredCommissionByNgrFtdWagerThresholdsQueryKeys.all] as const,
	detail: (id: string) => [...igamingTieredCommissionByNgrFtdWagerThresholdsQueryKeys.all, id] as const,
};
